import { Dialog, IconButton, Stack, Typography, styled } from '@mui/material';
import translations from 'utils/translations';
import React from 'react';
import { useIntl } from 'react-intl';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';

import CloseIcon from '@mui/icons-material/Close';
import ModalContent from './ModalContent';
import { useTicketsSelector } from 'pages/ticketV2/store/ticketsStore';

const EditTicketDatesDialog = ({ isOpen, onClose, onAccept, locale }) => {
  if (!isOpen) return null;
  const { ticketToEditDates } = useTicketsSelector();
  const owner = ticketToEditDates.unparsedTicket.owner_snap;
  const isOperator =
    owner.sdm_operator_type && owner.sdm_operator_type !== 'prv';
  const intl = useIntl();
  const i18nCommon = translations.TicketsV2(intl).Common;
  const i18nAssign = translations.TicketsV2(intl).Assign;

  const StyledDialog = styled(Dialog)({
    '& .MuiPaper-root': {
      borderRadius: '16px',
    },
  });

  return (
    <StyledDialog
      onClose={onClose}
      open={isOpen}
      maxWidth={'lg'}
      id="add-menu"
      keepMounted
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div style={{ padding: '30px' }}>
        <Stack
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'flex-end'}
        >
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
        <Stack gap={'25px'}>
          <Stack direction={'row'} alignItems={'center'} gap={'10px'}>
            <CalendarTodayOutlinedIcon fontSize="large" sx={{ mb: '4px' }} />
            <Typography variant="m-bold">{i18nCommon.editDate}</Typography>
          </Stack>
          <div>
            <Typography variant="body1">
              {!isOperator
                ? i18nAssign.datesSubtitle
                : `${i18nAssign.operatorDatesSubtitle} ${
                    ticketToEditDates?.unparsedTicket?.slots?.length || ''
                  }${i18nAssign.operatorDatesSubtitleDynamic}`}
            </Typography>
            {isOperator ? (
              <Typography variant="body1">
                {i18nAssign.operatorDatesSecondSubtitle}
              </Typography>
            ) : null}
          </div>
          <ModalContent onAccept={onAccept} locale={locale} />
        </Stack>
      </div>
    </StyledDialog>
  );
};
export default EditTicketDatesDialog;
